import FlexPane from './_flex-pane.js'
import AnimatedButton from './_animated-button.js'
import Text from './_text.js'
import Button from './_button.js'
import Image from './_image.js'
import DotNotification from './_dot-notification.js'
import Notification from './_notification.js'

export default {
  name: 'Cashout',
  values: {
    showUnavailableCashoutStatus: false,
    showInactiveCashoutStatus: true,
    errorNotificationTimeout: 10,
    confirmationTimeLimit: 30,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '0 8px 8px',
          flexDirection: 'column',
        },
      },
    },
    buttonsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    cashoutButton: {
      configSet: AnimatedButton,
      configValues: {
        success: {
          style: {
            base: {
              cursor: 'default',
            },
          },
        },
      },
    },
    cashoutButtonText: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          textAlign: 'center',
        },
      },
    },
    settingsButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            padding: '12px',
          },
        },
      },
    },
    settingsButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'settings',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    cancelButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: 'auto',
            alignItems: 'center',
            minWidth: '64px',
          },
        },
      },
    },
    cancelButtonLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          textAlign: 'center',
        },
      },
    },
    autoCashoutRuleDotNotification: {
      configSet: DotNotification,
      configValues: {
        style: {
          rootContainer: {
            top: '-4px',
            right: '-4px',
          },
          dot: {
            width: '8px',
            height: '8px',
          },
        },
      },
    },
    errorNotification: {
      configSet: Notification,
      configValues: {},
    },
    successNotification: {
      configSet: Notification,
      configValues: {},
    },
    warningNotification: {
      configSet: Notification,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
